// extracted by mini-css-extract-plugin
module.exports = {"copyrightWrapper":"Footer_copyrightWrapper__9eL3q","copyright":"Footer_copyright__327Ay"};